import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);
CustomEase.create("defaultEase", "0.8,0.31,0.2,0.7");

import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
Carousel.Plugins.Autoplay = Autoplay;

import "@fancyapps/ui/dist/carousel/carousel.css";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";


let currentSlideTL;
let slideAnimationTimeline;


let isScrollingUp = false;
let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

window.addEventListener('scroll', () => {
	const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

	isScrollingUp = currentScrollTop < lastScrollTop;

	lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
});


function handleSlideChange(instance) {
	// If there's an existing timeline, reverse it before killing
	if (currentSlideTL) {
		currentSlideTL.eventCallback("onReverseComplete", () => {
			currentSlideTL.kill();
			currentSlideTL = createSlideAnimationTimeline(instance);
			currentSlideTL?.play();
		});

		currentSlideTL.timeScale(2).reverse();
	} else {
		// First time and we set the carousel height (avoids title jumping)
		currentSlideTL = createSlideAnimationTimeline(instance);
		currentSlideTL?.play();

		setTimeout(() => {
			const bannerCarouselHeight = instance.container.querySelector('.f-carousel__slide.is-selected')?.offsetHeight;
			instance.container.style.height = `${bannerCarouselHeight}px`;
		}, 1000);
		
	}
}

function createSlideAnimationTimeline( instance ) {
	const bannerSlider = instance.container;
	if ( ! bannerSlider ) return null;

	const selectedSlide = bannerSlider.querySelector('.f-carousel__slide.is-selected');
	const selectedSlideData = selectedSlide?.querySelector('[data-name="slide-data"]');
	const selectedSlideText = selectedSlideData?.querySelector('[data-target="text"]');
	const selectedImageWrapper = selectedSlide?.querySelector('.image-wrapper');

	if (!selectedSlide) return null;

	const tl = gsap.timeline({ paused: true });

	tl
		.to( selectedSlideData, { backgroundColor: '', y: -10, duration: 0.5 } )
		.to( selectedSlideText, { autoAlpha: 1, height: 'auto', duration: 0.5 }, '<' )
		if ( window.innerWidth < 1280 ) {
			tl.to( selectedImageWrapper, { aspectRatio: '270 / 370', duration: 0.5 }, '<' )
		} else {
			tl.to( selectedImageWrapper, { aspectRatio: '295 / 320', duration: 0.5 }, '<' )
		}

	slideAnimationTimeline = tl;
	return tl;
}

function homeBanner(){
	const homeBanner = document.querySelectorAll('[data-block="homepage-banner"] .f-carousel');
	let homepageBannerSlider;

	if ( homeBanner.length > 0 ){
		homeBanner.forEach(homeBanner => {
			let data    = homeBanner.querySelectorAll('[data-name="slide-data"]');
			let caption = homeBanner.querySelectorAll('[data-target="caption"]');
			let text    = homeBanner.querySelectorAll('[data-target="text"]');

			gsap.set( data, { backgroundColor: 'transparent' } );
			gsap.set( caption, { autoAlpha: 0 } );
			gsap.set( text, { autoAlpha: 0, height: 0 } );

			homepageBannerSlider = new Carousel(homeBanner, {
				slidesPerPage: 1,
				center: true,
				initialPage: 2,
				infinite: true,
				Dots: true,
				Navigation: false, // We use custom navigation.
				Autoplay: {
					autoStart: false,
					timeout: 4000,
					pauseOnHover: true,
					//showProgress: false
				},
				on: {
					ready: (instance) => {
						instance.container.querySelector('.f-carousel__viewport').style.overflow = 'visible';  // Needed for the animation

						// Move dots.
						const defaultDots = instance.container.querySelector('.f-carousel__dots');
						const customContainer = document.querySelector('[data-name="banner-slider--dots"]');

						if (defaultDots && customContainer) {
							customContainer.appendChild(defaultDots);
						}

						// Custom navigation.
						document.getElementById('banner-slider--navigation--prevSlide')?.addEventListener('click', () => {
							instance.slidePrev();
						});
						document.getElementById('banner-slider--navigation--nextSlide')?.addEventListener('click', () => {
							instance.slideNext();
						});
					},
					change: handleSlideChange,
				}
			});
		});
	}

	return homepageBannerSlider;
}

function loadingAnimation(){
	const topNav      = document.querySelector('[data-name="top-nav"]');
	const topNavMenu  = document.querySelector('[data-name="top-nav-menu"]');
	const siteLogo    = document.querySelector('[data-name="top-nav-logo"]');

	const bgBannerPatternTop    = document.querySelector('[data-name="text-bg-pattern--top"]');
	const bgBannerPatternBottom = document.querySelector('[data-name="text-bg-pattern--bottom"]');
	
	const banner             = document.querySelector('[data-block="homepage-banner"]');
	const bannerTitle        = document.querySelector('[data-name="banner-title"]');
	const bannerText         = document.querySelector('[data-name="banner-text"]');
	const bannerSlider       = document.querySelector('[data-name="banner-slider"]');
	const bannerSliderSlides = document.querySelectorAll('[data-name="banner-slider--slide"]');
	const bannerNavigation   = document.querySelector('[data-name="banner-slider--navigation"]');
	const bannerDots         = document.querySelector('[data-name="banner-slider--dots"]');

	const slidingtabs = document.querySelector('[data-block="sliding-tabs"]');

	const bannerIntro        = document.querySelector('[data-block="homepage-introduction"]');
	gsap.set( bannerIntro, {  autoAlpha: 0 } );
	
	// Prepare animation.
	gsap.set( siteLogo, { autoAlpha: 0 } );
	gsap.set( topNavMenu, { autoAlpha: 0 } );
	gsap.set( bannerTitle, { autoAlpha: 0 } );
	gsap.set( bannerText, { autoAlpha: 0 } );
	gsap.set( bannerSlider, { autoAlpha: 0 } );
	gsap.set( bannerNavigation, { y: 30, autoAlpha: 0 } );
	gsap.set( bannerDots, { y: 30, autoAlpha: 0 } );
	gsap.set( bgBannerPatternTop, { y: '-100vh', autoAlpha: 0 } );
	gsap.set( bgBannerPatternBottom, { y: '100vh', autoAlpha: 0 } );
	if ( bannerSliderSlides.length > 0 ) {
		bannerSliderSlides.forEach(slide => {
			gsap.set( slide, { y: '-100vh' } );
			gsap.set( slide.querySelector('.overlay'), { alpha: '0' } );
		});
	}
	let hpBannerSlider



	// Loading animation.
	const loadingTL = gsap.timeline({
		defaults: {
			duration: 0.4,
			ease: 'defaultEase',
		},
		delay: 1,
		onComplete: () => {
			onScrollrevealAnimation( bgBannerPatternTop, bgBannerPatternBottom, topNav, banner, bannerTitle, bannerText, bannerSliderSlides, hpBannerSlider, bannerNavigation, bannerDots, bannerIntro, slidingtabs );
		}
	});

	loadingTL
		.add(() => {
			hpBannerSlider = homeBanner();
		})
		.to( bgBannerPatternTop, { y: '0vh', autoAlpha: 1, duration: 0.8 } )
		.to( bgBannerPatternBottom, { y: '0vh', autoAlpha: 1, duration: 0.8 }, '<' )
		.to( bannerTitle, { autoAlpha: 1 }, '<' )
		.to( bannerSlider, { autoAlpha: 1 }, '<' )
		.to( bannerSliderSlides, { y: 0, stagger: 0.2, ease: "power1.inOut" }, '<' )
		.add(() => {
			if (  hpBannerSlider ) {				
				let caption     = hpBannerSlider.container.querySelectorAll('[data-target="caption"]');
				let dataOverlay = hpBannerSlider.container.querySelectorAll('.overlay');

				gsap.to( caption, { autoAlpha: 1, duration: 0.5 } )
				gsap.to( dataOverlay, { alpha: '1', duration: 0.5 } )
				handleSlideChange( hpBannerSlider );
			}

			// Start autoplay.
			const autoplay = hpBannerSlider?.plugins?.Autoplay;
			if ( autoplay ) {
				autoplay.start();
			} else {
				console.warn("Autoplay plugin not attached");
			}
		})
		.to( bannerText, { autoAlpha: 1 }, '<' )
		.to( siteLogo, { autoAlpha: 1 }, '<' )
		.to( topNavMenu, { autoAlpha: 1 }, '<' )
		.to( bannerNavigation, { y: 0, autoAlpha: 1 }, '<' )
		.to( bannerDots, { y: 0, autoAlpha: 1 }, '<' )
}

function onScrollrevealAnimation( bgBannerPatternTop, bgBannerPatternBottom, topNav, banner, bannerTitle, bannerText, bannerSliderSlides, hpBannerSlider, bannerNavigation, bannerDots, bannerIntro, slidingtabs ){
	const bannerTL = gsap.timeline({
		scrollTrigger: {
			trigger: banner,
			start: 'top top',
			end: 'bottom top',
			scrub: 1,
			pin: true,
			pinSpacing: false,
			//markers: true,
		},
	});

	bannerTL
		.to( bgBannerPatternTop, { y: '-100vh', autoAlpha: 0, duration: 0.3 } )
		//.to( topNav, { y: '-100vh', autoAlpha: 0, duration: 0.3 }, '<' )
		.fromTo( bannerTitle, { autoAlpha: 1 }, { autoAlpha: 0, duration: 0.2 }, '-=0.2')
		.fromTo( bannerText, { autoAlpha: 1 }, { autoAlpha: 0, duration: 0.2 }, '<' )
		.to( bannerSliderSlides, { y: '-100vh', duration: 0.6 }, '<' )
		.add(() => {
			if ( ! slideAnimationTimeline ) return;			
			
			if ( isScrollingUp ) {
				// Slide timeline play and slider autoplay start.
				slideAnimationTimeline.play();
				hpBannerSlider?.plugins?.Autoplay?.start();				
			} else {
				// Slide timeline reverse and slider autoplay stop.
				slideAnimationTimeline.timeScale(1.5).reverse();
				hpBannerSlider?.plugins?.Autoplay?.stop();
			}
		}, '<')
		.to( bannerNavigation, {autoAlpha: 0, duration: 0.2 }, '<' )
		.to( bannerDots, {autoAlpha: 0, duration: 0.2 }, '<' )
		.to( bgBannerPatternBottom, { y: '-100vh' }, '<')
		.to( bannerIntro, { autoAlpha: 1 }, '-=0.4' )
		.fromTo( slidingtabs, { autoAlpha: 0, y: 200 }, { autoAlpha: 1, y: 0 }, '<' );
}

export default function() {
	if ( document.querySelector('body').classList.contains('page-template-home') ) {
		loadingAnimation();
	}
}
